export enum EntityReducers {
  sites = 'sites',
  settings = 'settings',
  preferences = 'preferences',
  surveyMeasurements = 'surveyMeasurements',
  surveys = 'surveys',
  loggerPrograms = 'loggerPrograms',
  leaks = 'leaks',
  application = 'application',
  loggerAudioFilters = 'loggerAudioFilters',
  masts = 'masts',
}
